module.exports = __webpack_public_path__ + "img/h3.10a68435.svg";